var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Renders a compact `SKU · UPC · ID` identifier line for a product row.
 * Empty identifiers are skipped; productId is always shown as a stable fallback.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
export var ProductIdentifierLine = function (_a) {
    var productId = _a.productId, productSku = _a.productSku, productUpc = _a.productUpc, className = _a.className;
    var t = useTranslation().t;
    var identifiers = [];
    if (productSku)
        identifiers.push({ label: t('SKU'), value: productSku });
    if (productUpc)
        identifiers.push({ label: t('UPC'), value: productUpc });
    identifiers.push({ label: t('ID'), value: productId });
    return (_jsx("p", __assign({ className: "truncate text-xs text-gray-500 " + (className || '') }, { children: identifiers.map(function (id, idx) { return (_jsxs(React.Fragment, { children: [idx > 0 && _jsx("span", __assign({ className: 'mx-1 text-gray-300' }, { children: "\u00B7" }), void 0), _jsxs("span", __assign({ className: 'font-semibold text-gray-400' }, { children: [id.label, ":"] }), void 0), ' ', _jsx("span", { children: id.value }, void 0)] }, id.label)); }) }), void 0));
};
export default ProductIdentifierLine;
